import React from "react";

const Loader = ({ className = "w-full h-64 bg-black" }) => {
  const spinnerStyle = {
    boxSizing: 'border-box',
    display: 'block',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-5em',
    marginLeft: '-5em',
    width: '10em',
    height: '10em',
    transformStyle: 'preserve-3d',
    transformOrigin: '50%',
    transform: 'rotateY(50%)',
    perspectiveOrigin: '50% 50%',
    perspective: '340px',
    backgroundSize: '10em 10em',
    backgroundImage: `url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjI2NnB4IiBoZWlnaHQ9IjI5N3B4IiB2aWV3Qm94PSIwIDAgMjY2IDI5NyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWxuczpza2V0Y2g9Imh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaC9ucyI+CiAgICA8dGl0bGU+c3Bpbm5lcjwvdGl0bGU+CiAgICA8ZGVzY3JpcHRpb24+Q3JlYXRlZCB3aXRoIFNrZXRjaCAoaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoKTwvZGVzY3JpcHRpb24+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS11aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4KICAgICAgICA8cGF0aCBkPSJNMTcxLjUwNzgxMywzLjI1MDAwMDM4IEMyMjYuMjA4MTgzLDEyLjg1NzcxMTEgMjk3LjExMjcyMiw3MS40OTEyODIzIDI1MC44OTU1OTksMTA4LjQxMDE1NSBDMjE2LjU4MjAyNCwxMzUuODIwMzEgMTg2LjUyODQwNSw5Ny4wNjI0OTY0IDE1Ni44MDA3NzQsODUuNzczNDM0NiBDMTI3LjA3MzE0Myw3NC40ODQzNzIxIDc2Ljg4ODQ2MzIsODQuMjE2MTQ2MiA2MC4xMjg5MDY1LDEwOC40MTAxNTMgQy0xNS45OTgwNDY4NSwyMTguMjgxMjQ3IDE0NS4yNzczNDQsMjk2LjY2Nzk2OCAxNDUuMjc3MzQ0LDI5Ni42Njc5NjggQzE0NS4yNzczNDQsMjk2LjY2Nzk2OCAtMjUuNDQ5MjE4NywyNTcuMjQyMTk4IDMuMzk4NDM3NSwxMDguNDEwMTU1IEMxNi4zMDcwNjYxLDQxLjgxMTQxNzQgODQuNzI3NTgyOSwtMTEuOTkyMjk4NSAxNzEuNTA3ODEzLDMuMjUwMDAwMzggWiIgaWQ9IlBhdGgtMSIgZmlsbD0iI0ZGRkZGRiIgc2tldGNoOnR5cGU9Ik1TU2hhcGVHcm91cCI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4=")`,
  };

  return (
    <>
      <style>{`
        @keyframes rotateBefore {
          from {transform: rotateX(60deg) rotateY(45deg) rotateZ(0deg); }
        to {transform: rotateX(60deg) rotateY(45deg) rotateZ(-360deg); }
        }
        @keyframes rotateAfter {
          from {transform: rotateX(240deg) rotateY(45deg) rotateZ(0deg); }
        to {transform: rotateX(240deg) rotateY(45deg) rotateZ(360deg); }
        }
      `}</style>
      <div className={`relative flex items-center justify-center overflow-hidden ${className}`}>
        <div className="spinner">
          <div className="spinner-before" style={{ ...spinnerStyle, animation: '750ms rotateBefore infinite linear reverse', transform: 'rotateX(60deg) rotateY(45deg) rotateZ(45deg)' }}></div>
          <div className="spinner-after" style={{ ...spinnerStyle, animation: '750ms rotateAfter infinite linear', transform: 'rotateX(240deg) rotateY(45deg) rotateZ(45deg)' }}></div>
        </div>
      </div>
    </>
  );
};

export default Loader;
